import { toastr } from 'react-redux-toastr';


export const saveText = textToSave => async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const user = firestore.auth().currentUser;
    // const today = new Date(Date.now());
    const entries = {
        content: textToSave,
        created: Date.now(),
    };

    try {
        await firestore.set(
            {
                collection: 'users',
                doc: user.uid,
                subcollections: [{ collection: 'entries', doc: Date.now().toString() }]
            },
            entries
        );
        // toastr.success('Success', 'Text Saved');

    } catch (error) {
        console.log(error);
    }
};

export const deleteText = textToDeleteID => async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();
    const user = firestore.auth().currentUser;
    console.log(textToDeleteID);
    try {
        await firestore.delete({
            collection: 'users',
            doc: user.uid,
            subcollections: [{ collection: 'entries', doc: textToDeleteID }]
        });
    } catch (error) {
        console.log(error);
    }
};



// WEBPACK FOOTER //
// ./src/Components/SavedPage/userActions.jsx